import React, { useCallback } from 'react';
import { makeStyles, Checkbox, Slider, TextField, withStyles, Select, MenuItem } from '@material-ui/core';
import { SubMenuProps, HeightOption } from '../LabelSubMenu';
import { ballGroundZ } from '../BallLabelTask';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  checkbox: {
    color: "#444",
    '&.Mui-checked': {
      color: "#444",
    },
  },
  sliderDiv: {
    position: 'absolute',
    top: 10,
    right: 0,
  },
  textInput: {
    marginTop: '10px',
    width: 70,
  },
}));

const HeightSliderSubMenu = (props: SubMenuProps) => {
  const classes = useStyles();

  const {
    wasInAir,
    zValue,
    onChangeWasInAir,
    onChangeZValue,
    presets,
  } = props;

  const handleWasInAir = useCallback(() => {
    onChangeWasInAir(!wasInAir);
  }, [onChangeWasInAir, wasInAir]);

  const handleSlider = useCallback((event: React.ChangeEvent<{}>, value: number | number[]) => {
    onChangeZValue(Number(-value));
  }, [onChangeZValue]);

  const handleTextEdit = useCallback((event) => {
    onChangeZValue(Number(event.target.value));
  }, [onChangeZValue]);

  const handlePresetSelect = useCallback((event) => {
    onChangeZValue(event.target.value)
  }, [onChangeZValue]);

  return <div className={classes.container}>
    <div>
      Was In Air:
      <Checkbox
        checked={wasInAir}
        onChange={handleWasInAir}
        className={classes.checkbox}
      />
    </div>
    { wasInAir && <>
      { presets && presets.length > 0 && <div>
          <Select
            value={zValue}
            onChange={handlePresetSelect}
            MenuProps={{
              style: {zIndex: 35001}
            }}
          >
            {
              presets.map((option: HeightOption) => 
                <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
              )
            }
          </Select>
        </div>
      }
      <div>
        <TextField
          type="number"
          value={zValue}
          onChange={handleTextEdit}
          label="height (m)"
          inputProps={{ step: 0.05, min: ballGroundZ }}
          className={classes.textInput}
        />
        <CustomSlider
          className={classes.sliderDiv}
          key="heightEst"
          value={-zValue}
          step={0.05}
          orientation="vertical"
          marks={[
            {
              value: -ballGroundZ,
              label: '-',
            },
            {
              value: -2,
              label: '2m',
            },
            {
              value: -5,
              label: '5m',
            },
          ]}
          min={-8}
          max={-ballGroundZ}
          valueLabelDisplay="off"
          onChange={handleSlider}
        />
      </div>
    </>}
  </div>
}

const CustomSlider = withStyles({
  root: {
    color: '#ffffff',
    maxHeight: '160px',
  },
  thumb: {
    height: 16,
    width: 16,
    backgroundColor: '#0069',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -8,
    '&:focus, &:hover': {
      boxShadow: '0px 0px 0px 8px #ff5b0f18'
    },
    '&$active': {
      boxShadow: '0px 0px 0px 12px #ff5b0f3e'
    },
    opacity: 1,
  },
  active: {},
  track: {
    height: 8,
    borderRadius: 4,
    backgroundColor: '#ffffff',
  },
  rail: {
    height: 8,
    borderRadius: 4,
    opacity: 1,
  },
  vertical: {
    '& $rail': {
      width: 12,
      backgroundColor: '#ff5a0f',
    },
    '& $track': {
      width: 12,
    },
    '& $thumb': {
      marginLeft: -2,
      marginBottom: -8,
    }
  }
})(Slider)

export default HeightSliderSubMenu;

